<div [formGroup]="parentForm" id="extra-prompts-container" *ngIf="!(formState$ | async)?.loading">
  <mm-ach-transfer-direction [parentForm]="extraPromptsGroup" [instructions$]="instructions$"
                             class="big-bottom-spacer"></mm-ach-transfer-direction>
  <mm-ach-source-of-funds *ngIf="showTargetOfFunds"
                          [parentForm]="extraPromptsGroup"
                          [instructions$]="instructions$"
                          [directionSelection$]="directionSelection$"
                          class="big-bottom-spacer">
  </mm-ach-source-of-funds>
  <mm-ach-requesting-account-holder *ngIf="showRequestingAccountHolder"
                                    [parentForm]="extraPromptsGroup" [customers$]="customers$"
                                    [ngClass]="(requestingAccountHolderCount > 1) ? 'big-bottom-spacer' : ''"
                                    data-testid='ach-requesting-account-holder'>
  </mm-ach-requesting-account-holder>
  <mm-radio-control *ngIf="showFrequencySelection" [parentForm]="extraPromptsGroup"
                    [radioModel]="frequencySelectorModel" class="big-bottom-spacer" data-testid="frequencyControl">
  </mm-radio-control>
</div>
